<template>
    <div>
        <div class="room" :class="roomStatusClass">
            <!-- 房号 -->
            <div class="num">
                <div class="text">{{ room.houseNum }}</div>
                <drop-down-self
                    class="drop-down-self"
                    :list="menuList"
                    @on-click="onClickMenuItem"
                />
            </div>
            <!-- 状态-圆 -->
            <div class="state">{{ stateText }}</div>
            <!-- 信息 -->
            <div class="content">
                <div class="info">
                    <div v-if="isRent">
                        {{ room.cusMobile }}
                    </div>
                    <div v-if="isRent">
                        {{ room.cusName }}
                    </div>
                    <div v-if="isBook">{{ room.houseStatusText }}</div>
                    <div v-if="isEmpty">
                        空<span style="color: red">{{ room.days }}</span
                        >天
                    </div>
                    <div v-if="isEmpty" :class="{ red: room.surrenderTextRed }">
                        {{ room.surrenderText }}
                    </div>
                    <div
                        v-if="isInvalid"
                        style="color: #c1c1c1; margin-top: 20px"
                    >
                        <div>作废时间</div>
                        <div>{{ room.updateTime | ymdL }}</div>
                    </div>
                    <div v-if="isLocked">{{ room.houseStatusText }}</div>
                </div>

                <!-- 提示消息 -->
                <div>
                    <div class="overdue" v-if="room.contractStatus === '6'">
                        合同逾期
                    </div>
                    <div
                        class="maturity"
                        v-else-if="room.contractStatus === '5'"
                    >
                        合同即将到期
                    </div>
                </div>
            </div>
            <!-- 租金 -->
            <div
                class="price"
                v-bind:class="{ 'price-invalid': room.isInvalid }"
                v-if="room.showPrice"
            >
                {{ room.showPrice }}元/月
            </div>
        </div>
    </div>
</template>

<script>
import DropDownSelf from '_vc/drop-down-self'
export default {
    name: 'Room',
    components: { DropDownSelf },
    data() {
        return {
            stateText: '',
            menuList: [],
            roomStatusClass: '',
        }
    },
    props: {
        room: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    created() {
        this.initMenu()
        this.initStatus()
    },
    computed: {
        isEmpty() {
            return this.room.isEmpty
        },
        isBook() {
            return this.room.isBook
        },
        isRent() {
            return this.room.isRent
        },
        isInvalid() {
            return this.room.isInvalid
        },
        isLocked() {
            return this.room.isLocked
        },
    },
    methods: {
        initMenu() {
            let list = []
            const { isEmpty, isBook, isRent, isInvalid, isLocked } = this
            const { contractStatus } = this.room

            // 权限
            const canUpdate = this.$can('update'),
                canView = this.$can('view'),
                canDelete = this.$can('delete'),
                canInputBook = this.$can('book'),
                canStopBook = this.$can('stopBook'),
                canLock = this.$can('lock'),
                canAddContract = this.$can('addContract')

            // 操作
            // 录入预定
            if (isEmpty && canInputBook) {
                list.push({ text: '录入预定信息', key: 'inputBook' })
            }
            // 查看预定
            if (isBook) {
                list.push({ text: '查看预定信息', key: 'viewBook' })
            }
            // 终止预定
            if (isBook && canStopBook) {
                list.push({ text: '终止预定', key: 'stopBook' })
            }
            // 录入合同
            if ((isEmpty || isBook) && canAddContract) {
                list.push({ text: '录入合同', key: 'inputContract' })
            }
            // 查看合同
            if (isRent && canView) {
                list.push({ text: '查看合同', key: 'viewContract' })
            }
            // 出租记录
            if (contractStatus && canView) {
                list.push({ text: '出租记录', key: 'rentRecording' })
            }
            // 抄表记录
            if (contractStatus && canView) {
                list.push({ text: '抄表记录', key: 'meterRecording' })
            }
            // 查看房间
            if (canView) {
                list.push({ text: '查看房间', key: 'viewRoom' })
            }
            // 修改房间
            if (canUpdate) {
                list.push({ text: '修改房间', key: 'updateRoom' })
            }
            // 删除房间
            if (isEmpty && canDelete) {
                list.push({ text: '删除房间', key: 'deleteRoom' })
            }
            // 拆分房间
            if (isEmpty && canUpdate) {
                list.push({ text: '拆分房间', key: 'splitRoom' })
            }
            // 锁定房间
            if (isEmpty && canLock) {
                list.push({ text: '锁定房间', key: 'lockRoom' })
            }
            // 解锁房间
            if (isLocked && canLock) {
                list.push({ text: '解锁房间', key: 'unlockRoom' })
            }
            this.menuList = list
        },
        initStatus() {
            const { isEmpty, isBook, isRent, isInvalid, isLocked } = this
            const { contractStatus } = this.room
            let roomStatusClass = ''

            // 中途、到期退租文字
            if (isEmpty && contractStatus) {
                if (contractStatus === '26') {
                    this.room.surrenderText = '违约退租'
                    this.room.surrenderTextRed = true
                } else if (contractStatus === '25') {
                    this.room.surrenderText = '到期退租'
                }
            }

            if (isEmpty) {
                roomStatusClass = 'room-empty'
                this.stateText = '空'
            }
            if (isBook) {
                roomStatusClass = 'room-booking'
                this.stateText = '预'
            }
            if (isRent) {
                roomStatusClass = 'room-full'
                this.stateText = '住'
            }
            if (isInvalid) {
                roomStatusClass = 'room-invalid'
                this.stateText = '无'
            }
            if (isLocked) {
                roomStatusClass = 'room-lock'
                this.stateText = '锁'
            }
            this.roomStatusClass = roomStatusClass
        },

        onClickMenuItem(name) {
            const obj = { name, room: this.room }
            this.$emit('menuItemClick', obj)
        },
    },
}
</script>

<style lang="less" scoped>
.room {
    width: 120px;
    height: 180px;
    background-color: rgb(255, 255, 255);
    box-shadow: rgba(215, 215, 215, 0.35) 2px 2px 8px;
    position: relative;
    // overflow: hidden;
    // 房号
    .num {
        height: 67px;
        border-radius: 0px 0px 50% 50% / 25% 25%;
        text-align: center;
        font-size: 14px;
        color: white;
        .text {
            line-height: 46px;
        }
        .menu {
            position: absolute;
            top: 0px;
            right: 0px;
        }
        .drop-down-self {
            position: absolute;
            top: 0px;
            right: 0px;
            z-index: 999;
        }
    }
    // 状态——圆
    .state {
        width: 37px;
        height: 37px;
        border-radius: 50%;
        font-size: 14px;
        position: absolute;
        top: 46px;
        left: 50%;
        transform: translateX(-50%);
        // background-color: #333;
        text-align: center;
        line-height: 37px;
        color: white;
    }

    .content {
        height: 90px;
        padding: 25px 0px 12px;
        text-align: center;
        .info {
            height: 47px;
        }
        .overdue {
            color: #ff3739;
        }
        .maturity {
            color: #f59a23;
        }
    }

    .price {
        height: 16px;
        font-size: 12px;
        font-weight: 400;
        text-align: center;
        color: rgb(44, 141, 240);
    }
    .price-invalid {
        color: #7d7d7d;
    }

    // 房间的三种状态
    &-empty {
        .num {
            background: linear-gradient(to right, #f59a23, #facd91);
        }
        .state {
            background-color: #d7d7d7;
        }
    }

    &-full {
        .num {
            background: linear-gradient(to right, #02a7f0, #81d3f8);
        }
        .state {
            background-color: #2c8df0;
        }
    }

    &-booking {
        .num {
            background: linear-gradient(to right, #00bfbf, #7ee0e0);
        }
        .state {
            background-color: #00bfbf;
        }
    }
    &-invalid {
        .num {
            background: linear-gradient(to right, #aaaaaa, #d8d8d8);
        }
        .state {
            background-color: #d7d7d7;
        }
    }
    &-lock {
        .num {
            background: linear-gradient(to right, #f66424, #fab191);
        }
        .state {
            background-color: #f4623b;
        }
    }
    .red {
        color: red;
    }
}
</style>

<style scoped>
.num {
    border-radius: 0px 0px 50% 50% / 35% 35%;
}
</style>
